import React from "react";
import RadioInput from "../../Common/FormElements/RadioInput/RadioInput";
import CustomTooltip from "../../Common/CustomTooltip/CustomTooltip";
import { useDispatch, useSelector } from "react-redux";
import { updateCart } from "../../../REDUX/actions/catalogue";
import { useTranslation } from "react-i18next";
import useCanSeePrices from "../../../hooks/useCanSeePrices";

const DeliveryOptionNew = ({
  deliveryOption,
  manual,
  storeIcon,
  option = "",
  checkedOption = "",
  setSelectedDelivery,
  selectedDelivery,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.catalogueReducer);
  const canSeePrices = useCanSeePrices();

  return (
    <div
      onClick={() => {
        setSelectedDelivery(deliveryOption);
        dispatch(
          updateCart(cart.id, {
            delivery_type: deliveryOption.id,
            deliveryPrice: deliveryOption.price,
            deliveryOptionName: deliveryOption.name,
            facture: null,
            bon_de_commande: null,
          })
        );
      }}
    >
      <div
        className={`deliveryOption px-3 mb-3 d-flex align-items-center justify-content-between b-1-darkGrey br5 pointer ${
          deliveryOption.name === selectedDelivery.name ? "selected" : ""
        }`}
      >
        <div className="d-flex align-items-center">
          <RadioInput
            name="delivery"
            checked={deliveryOption.name === selectedDelivery.name}
          />
          {storeIcon ? (
            <i className="bi bi-shop-window f44 text-brightGrey mx-5" />
          ) : (
            <i className="bi bi-truck f44 text-brightGrey mx-5" />
          )}
          <div>
            <p className="f16 sBold text-customBlack mb-0">
              {option} &nbsp;{" "}
              <span className="text-blue">{t(`${deliveryOption.name}`)}</span>
            </p>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end gap-2">
          {manual && deliveryOption.name === selectedDelivery.name && (
            <input
              style={{ outline: "none" }}
              className="text-end p-2 pe-2 w-50 ms-auto textInput br6 normal border"
              type="number"
              defaultValue={
                // cart?.majorAccountOrder &&
                // cart?.currency === "Dollar" &&
                // cart?.exchangeRate
                //   ? cart.deliveryPrice / cart?.exchangeRate
                //   :
                cart.deliveryPrice
              }
              onChange={(e) =>
                dispatch(
                  updateCart(cart.id, {
                    deliveryPrice:
                      // cart?.majorAccountOrder &&
                      // cart?.currency === "Dollar" &&
                      // cart?.exchangeRate
                      //   ? e.target.value * cart?.exchangeRate :
                      e.target.value,
                    facture: null,
                    bon_de_commande: null,
                  })
                )
              }
            />
          )}
          {/* A commercial sees no delivery price (the store's cost). */}
          {canSeePrices && (checkedOption?.trim() === option.trim() || !manual) && (
            <CustomTooltip
              delivery
              title={
                <div className="f18 bold text-start text-customBlack mb-0">
                  {manual ? (
                    ""
                  ) : (
                    <div>
                      <p
                        className="f12 m-0"
                        dangerouslySetInnerHTML={{
                          __html: deliveryOption.explanation,
                        }}
                      ></p>
                    </div>
                  )}
                </div>
              }
            >
              <div className="bold">
                {
                  // cart?.majorAccountOrder &&
                  // cart?.currency === "Dollar" &&
                  // cart?.exchangeRate &&
                  // deliveryOption.price
                  //   ? (deliveryOption.price / cart?.exchangeRate)?.toFixed(2)
                  deliveryOption.price
                }{" "}
                {/* {cart?.majorAccountOrder && cart?.currency === "Dollar"
                  ? " $" */}
                {" €"}{" "}
                <span className="f10">
                  {cart.particulier ? t("Incl. Tax") : t("Excl. Tax")}
                </span>
              </div>
            </CustomTooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryOptionNew;
